import { CompetencyFiltersResponse, isCompetencyFiltersResponse } from '~/modules/types/competencyFilters';
import { http } from '~/modules/utilities/http';

export async function getCompetencyFilters(): Promise<CompetencyFiltersResponse> {
    // This public BFF stays on the page origin, including AgentExchange's /jp routes.
    const { data } = await http.get('/api/competency-filters', {
        timeout: 12_000,
        // The store owns the anticipated static-data fallback; do not double-log at the HTTP layer.
        suppressErrorLogging: true,
    });
    if (!isCompetencyFiltersResponse(data)) {
        throw new Error('Malformed competency filters response');
    }
    return data;
}
